export enum AttachmentTypeEnum {
  APPROVAL = 'APPROVAL',
  CERTIFIED_ID = 'CERTIFIED_ID',
  CONTRACT = 'CONTRACT',
  CORRECTION_NOTE = 'CORRECTION_NOTE',
  COUNTERSIGNED_CONTRACT = 'COUNTERSIGNED_CONTRACT',
  ID_DOCUMENT = 'ID_DOCUMENT',
  LICENSE = 'LICENSE',
  PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
  SPECIAL_AGREEMENT = 'SPECIAL_AGREEMENT',
  SUPPORTING_DOCUMENT = 'SUPPORTING_DOCUMENT',
  TAX_OFFICE_REGISTRATION = 'TAX_OFFICE_REGISTRATION',
}

export const AttachmentType = {
  APPROVAL: AttachmentTypeEnum.APPROVAL,
  CERTIFIED_ID: AttachmentTypeEnum.CERTIFIED_ID,
  CONTRACT: AttachmentTypeEnum.CONTRACT,
  CORRECTION_NOTE: AttachmentTypeEnum.CORRECTION_NOTE,
  COUNTERSIGNED_CONTRACT: AttachmentTypeEnum.COUNTERSIGNED_CONTRACT,
  ID_DOCUMENT: AttachmentTypeEnum.ID_DOCUMENT,
  LICENSE: AttachmentTypeEnum.LICENSE,
  PROOF_OF_ADDRESS: AttachmentTypeEnum.PROOF_OF_ADDRESS,
  SPECIAL_AGREEMENT: AttachmentTypeEnum.SPECIAL_AGREEMENT,
  SUPPORTING_DOCUMENT: AttachmentTypeEnum.SUPPORTING_DOCUMENT,
  TAX_OFFICE_REGISTRATION: AttachmentTypeEnum.TAX_OFFICE_REGISTRATION,
};
